module.exports = __webpack_public_path__ + "media/images/facebook-940b757fcdd8b67c4252ccded1454c7e.svg";